import { render, staticRenderFns } from "./CardLoading.vue?vue&type=template&id=61a71c33&"
import script from "./CardLoading.vue?vue&type=script&lang=js&"
export * from "./CardLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a71c33')) {
      api.createRecord('61a71c33', component.options)
    } else {
      api.reload('61a71c33', component.options)
    }
    module.hot.accept("./CardLoading.vue?vue&type=template&id=61a71c33&", function () {
      api.rerender('61a71c33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/cards/CardLoading.vue"
export default component.exports